import { render, staticRenderFns } from "./center-navigation.vue?vue&type=template&id=5ea15a74&"
import script from "./center-navigation.vue?vue&type=script&lang=js&"
export * from "./center-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports